import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import BiblicalDefenseTool from "@/components/BiblicalDefenseTool";
import AtheismTool from "@/components/AtheismTool";
import MoralDilemmasTool from "@/components/MoralDilemmasTool";
import InterfaithDialogueTool from "@/components/InterfaithDialogueTool";
import EvangelismAssistantTool from "@/components/EvangelismAssistantTool";
import { useLocation, useNavigate } from "react-router-dom";

interface ToolSelectorProps {
  selectedTool: string | null;
  setSelectedTool: (tool: string | null) => void;
}

const ToolSelector = ({ selectedTool, setSelectedTool }: ToolSelectorProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Handle back button click
  const handleBackClick = () => {
    // Navigate back to the main apologetics page without a hash
    navigate("/apologetics", { replace: true });
    setSelectedTool(null);
  };

  const renderSelectedTool = () => {
    switch (selectedTool) {
      case "biblical-defense":
        return <BiblicalDefenseTool />;
      case "atheism":
        return <AtheismTool />;
      case "evangelism-assistant":
        return <EvangelismAssistantTool />;
      case "moral-dilemmas":
        return <MoralDilemmasTool />;
      case "interfaith-dialogue":
        return <InterfaithDialogueTool />;
      default:
        return null;
    }
  };

  if (!selectedTool) return null;

  return (
    <div className="min-h-screen bg-white">
      <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-4 py-2">
        <Button 
          variant="ghost" 
          onClick={handleBackClick} 
          className="flex items-center gap-2"
        >
          <ArrowLeft size={16} />
          <span>Back to Apologetics</span>
        </Button>
      </div>
      <div className="container mx-auto px-4 py-6">
        {renderSelectedTool()}
      </div>
    </div>
  );
};

export default ToolSelector;
